import React from "react";
import { Switch } from "react-router-dom";
import Index from "./Index";
import { PrivateRoute } from 'lib/widget'

export default () => (
    <Switch>
        <PrivateRoute path="/system/transfer-customer" component={Index} perm="system_user_transfer_customer_data" />
    </Switch>
);